import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { addShopifySalesChannelApi, deleteShopifySalesChannelApi, getShopifySalesChannelApi, updateShopifySalesChannelApi } from "../../../services/partners/settings/shopifySalesChannelService";


export const getAllPartnerShopifySalesChannels = createAsyncThunk("partner/getAllPartnerShopifySalesChannels", async (filters, { dispatch }) => {
  const response = await getShopifySalesChannelApi(filters);
  return response.response;
});

export const addPartnerShopifySalesChannels = createAsyncThunk("partner/addPartnerShopifySalesChannels", async (duration, { dispatch, getState }) => {
  try {
    const response = await addShopifySalesChannelApi(duration);
    const data = await response.response;
    toast.success("Add Partner Shopify Sales Channels successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

export const updatePartnerShopifySalesChannels = createAsyncThunk("partner/updatePartnerShopifySalesChannels", async (duration, { dispatch, getStatus }) => {
  try {
    const response = await updateShopifySalesChannelApi(duration, duration.id);
    const data = await response.response;
    toast.success("Update Partner Shopify Sales Channels successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

export const deletePartnerShopifySalesChannels = createAsyncThunk("partner/deletePartnerShopifySalesChannels", async (id, { dispatch, getStatus }) => {
  try {
    const response = await deleteShopifySalesChannelApi(id);
    const data = await response.response;
    toast.success("Deleted Partner Shopify Sales Channels successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

const partnerShopifySalesChannelsAdapter = createEntityAdapter({});

export const { selectAll: selectPartnerShopifySalesChannels, selectById: selectPartnerShopifySalesChannelsId } = partnerShopifySalesChannelsAdapter.getSelectors(
  (state) => state.partner.partnerShopifySalesChannels
);

const partnerShopifySalesChannelsSlice = createSlice({
  name: "partnerShopifySalesChannels",
  initialState: partnerShopifySalesChannelsAdapter.getInitialState({
    searchText: "",
    addDialog: {
      component: "PartnerShopifySalesChannels",
      type: "new",
      props: {
        open: false,
      },
      data: null,
    },
  }),
  reducers: {
    setPartnerShopifySalesChannelsSearchText: {
      reducer: (state, action) => {
        state.searchText = action.payload;
      },
      prepare: (event) => ({ payload: event.target.value || "" }),
    },
    openNewDialog: (state, action) => {
      state.addDialog = {
        component: "PartnerShopifySalesChannels",
        type: "new",
        props: {
          isOpen: true,
        },
        data: null,
      };
    },
    openEditDialog: (state, action) => {
      state.addDialog = {
        type: "edit",
        props: {
          isOpen: true,
        },
        data: action.payload,
      };
    },
    closeEditDialog: (state, action) => {
      state.addDialog = {
        type: "edit",
        props: {
          isOpen: false,
        },
        data: null,
      };
    },
  },
  extraReducers: {
    [getAllPartnerShopifySalesChannels.fulfilled]: partnerShopifySalesChannelsAdapter.setAll,
  },
});

export const { setPartnerShopifySalesChannelsSearchText, openNewDialog, closeNewDialog, openEditDialog, closeEditDialog } = partnerShopifySalesChannelsSlice.actions;

export default partnerShopifySalesChannelsSlice.reducer;
